module.exports = __webpack_public_path__ + "img/royabishop.1b76cd05.jpg";